var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-gift"},[_c('div',{staticClass:"ribbon-top"}),_c('div',{staticClass:"heading"},[_vm._t("default")],2),_c('div',{staticClass:"ribbon-bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }